import React from 'react';
import { Flex } from '@resideo/blueprint-react';
import {
  ParentContainer,
  CenteredContainer,
  PageLayoutContainer,
  PageDescription,
} from './PageLayout.style';
import Breadcrumbs from 'components/common/Breadcrumbs';
import { PageLayoutType } from './PageLayout.types';
import Typography from 'components/common/Typography';

const { Title } = Typography;

/**
 * PageLayout component
 *
 * @prop title - title that's going to be shown in the layout
 * @prop titleSide - content to be shown inline with the title like CTA's buttons or links
 * @prop hideBreadcrumbs
 *
 * @usage
 *
 * ```js
 * const { Description } = PageLayout;
 *
 * <PageLayout title="Page title" titleSide="Edit">
 *  <Description>
 *    This is the site description
 *  </Description>
 *</Tabs>
 * ```
 */
const PageLayout: PageLayoutType = ({
  children,
  title,
  titleSide,
  hideBreadcrumbs = false,
  ...rest
}) => (
  <ParentContainer>
    <CenteredContainer>
      <PageLayoutContainer {...rest}>
        {!hideBreadcrumbs && (
          <Flex flex={1} marginBottom={32} paddingTop={16}>
            <Breadcrumbs />
          </Flex>
        )}
        {title && (
          <Flex flex={1} alignItems='center' justifyContent='space-between'>
            <Title level={1} strong='true'>
              {title}
            </Title>
            {titleSide}
          </Flex>
        )}
        <Flex flex={1} flexDirection='column'>
          {children}
        </Flex>
      </PageLayoutContainer>
    </CenteredContainer>
  </ParentContainer>
);

PageLayout.Description = PageDescription;

export default PageLayout;
